<template>
  <div class="header-container">
    <div class="header-top">
      <div class="header-top-left">
        <img src="../assets/home/top-logo.png" alt="">
        <div class="m-l-24 left-title">{{$t('header.title')}}</div>
      </div>
      <div class="header-top-right">
        <div :class="(tabIndex === item.id) ? 'active': '' " v-for="item in tabs" :key="item.id" @click="onChange(item)">{{item.title}}</div>
      </div>
    </div>
    <div class="lang">
      <el-dropdown trigger="click" placement="bottom-start" @command="langChange">
        <div class="lang-box el-dropdown-link">
          <img v-if="$i18n.locale == 'zh'" src="../assets/home/zh_CN.png">
          <img v-else src="../assets/home/en_US.png">
          <span>{{ langtitle }}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="zh">
            <div class="dropDownImg">
              <img src="../assets/home/zh_CN.png">
              <div>Chinese</div>
            </div>
          </el-dropdown-item>
          <el-dropdown-item command="en">
            <div class="dropDownImg">
              <img src="../assets/home/en_US.png">
              <div>English</div>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
  import router from "@/router";
  import {mapState} from 'vuex'
  export default {
    data() {
      return {
      }
    },
    computed: {
      ...mapState(['tabIndex']),
      tabs() {
        return [
          {id: 0, url: '/home', title: this.$t('header.page1')},
          {id: 1, url: '/witstar', title: this.$t('header.page2')},
          {id: 3, url: '/brandOverseas', title: this.$t('header.page6')},
          {id: 4, url: '/success', title: this.$t('header.page3')},
          {id: 5, url: '/serve', title: this.$t('header.page4')},
          {id: 6, url: '/contact', title: this.$t('header.page5')},
        ]
      },
      langtitle() {
        return this.$i18n.locale == 'zh' ? 'Chinese' : 'English'
      }
    },
    methods: {
      onChange(item) {
        if (this.tabIndex == item.id) return
        this.$store.commit('setTabIndex', item.id)
        router.push(item.url)
      },
      langChange(e) {
        localStorage.setItem('lang', e)
        this.$i18n.locale = e
      }
    }
  }
</script>
<style lang="scss" scoped>
.zh {
  .header-top {
    width: 68%;
    .left-title {
      font-size: 20px;
      font-weight: bold;
    }
    .header-top-right {
      font-size: 18px;
    }
  }
}
.en {
  .header-top {
    width: 86%;
    .left-title {
      font-size: 18px;
      font-weight: bold;
    }
    .header-top-right {
      font-size: 16px;
    }
  }
}

.lang {
  position: absolute;
  top: 0;
  right: 50px;
  cursor: pointer;
  box-sizing: border-box;
  z-index: 999;
  cursor: pointer;
  .lang-box{
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    color: #424242;
    background: rgba(255,255,255,0.8);
    box-shadow: 0 0 6px rgba(0,0,0,.25);
    border-radius: 6px;
    font-weight: bold;
    padding: 8px 10px;
    box-sizing: border-box;
    img {
      width: 18px;
      height: 12px;
      vertical-align: middle;
      margin-right: 4px;
    }
  }
}


::v-deep.el-dropdown-menu {
  background: rgba(46, 46, 56, .8);
  padding: 0px;
  margin: 0px;
  border: none;
  border-radius: 10px;
  box-shadow: 0 0 6px rgba(0,0,0,.25);
  padding: 10px;
  top: 45px !important;
  .el-dropdown-menu__item {
    font-size: 16px;
    color: #fff;
    padding: 2px 10px;
    border-radius: 8px;
    .dropDownImg {
      display: flex;
      align-items: center;
      img {
        width: 18px;
        height: 12px;
        margin-right: 4px;
        vertical-align: middle;
      }
    }
  }
  .el-dropdown-menu__item:not(.is-disabled):hover {
    color: #424242 !important;
  }
  .popper__arrow {
    border-bottom-color: rgba(46, 46, 56, .8) !important;
  }
  .popper__arrow::after {
    border-bottom-color: rgba(46, 46, 56, .8) !important;
  }
}

.header-container {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 11;

  .header-top {
    //width: 68%;
    height: 110px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header-top-left {
      display: flex;
      align-items: center;
      img {
        height: 70px;
        width: 191px;
        vertical-align: middle;
      }
    }
    .header-top-right {
      display: flex;
      font-weight: 400;
      div {
        margin-right: 50px;
        cursor: pointer;
        padding: 10px 0px;
      }
      .active {
        border-bottom: 2px solid #FABB15;
      }
    }
  }
}
</style>